var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import pointRadial from "../pointRadial.js";
var Bump = /** @class */ (function () {
    function Bump(context, x) {
        this._context = context;
        this._x = x;
    }
    Bump.prototype.areaStart = function () {
        this._line = 0;
    };
    Bump.prototype.areaEnd = function () {
        this._line = NaN;
    };
    Bump.prototype.lineStart = function () {
        this._point = 0;
    };
    Bump.prototype.lineEnd = function () {
        if (this._line || (this._line !== 0 && this._point === 1))
            this._context.closePath();
        this._line = 1 - this._line;
    };
    Bump.prototype.point = function (x, y) {
        x = +x, y = +y;
        switch (this._point) {
            case 0: {
                this._point = 1;
                if (this._line)
                    this._context.lineTo(x, y);
                else
                    this._context.moveTo(x, y);
                break;
            }
            case 1: this._point = 2; // falls through
            default: {
                if (this._x)
                    this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else
                    this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
            }
        }
        this._x0 = x, this._y0 = y;
    };
    return Bump;
}());
var BumpRadial = /** @class */ (function () {
    function BumpRadial(context) {
        this._context = context;
    }
    BumpRadial.prototype.lineStart = function () {
        this._point = 0;
    };
    BumpRadial.prototype.lineEnd = function () { };
    BumpRadial.prototype.point = function (x, y) {
        var _a, _b;
        x = +x, y = +y;
        if (this._point++ === 0) {
            this._x0 = x, this._y0 = y;
        }
        else {
            var p0 = pointRadial(this._x0, this._y0);
            var p1 = pointRadial(this._x0, this._y0 = (this._y0 + y) / 2);
            var p2 = pointRadial(x, this._y0);
            var p3 = pointRadial(x, y);
            (_a = this._context).moveTo.apply(_a, p0);
            (_b = this._context).bezierCurveTo.apply(_b, __spreadArrays(p1, p2, p3));
        }
    };
    return BumpRadial;
}());
export function bumpX(context) {
    return new Bump(context, true);
}
export function bumpY(context) {
    return new Bump(context, false);
}
export function bumpRadial(context) {
    return new BumpRadial(context);
}
